import React from 'react'
// components
import DetailsForm from 'components/Modals/PlanItems/Action/MinimizedModal/components/DetailsSection/components/DetailsForm'
import PlanLinks from 'components/Modals/PlanItems/components/PlanLinks'
import AdditionalModalActions from 'components/Modals/PlanItems/components/AdditionalModalActions'
// context
import { ActionContext } from 'context'
import { DetailsModalActionsContext } from 'containers/MinimizedObjectivesList/layers/Business/DetailsModalActions'
// hocs
import { withDropzone } from 'hocs'
// hooks
import { useInitialValues } from 'hooks/useInitialValues'
// constants
import { Forms, ENTITIES } from 'constants/index'
// graphql
import { PLAN_ACTION_DETAILS_QUERY } from 'graphql/planActions/queries'
// views
import { DetailsSectionWrapper as Wrapper } from 'components/Modals/PlanItems/styles'

const DetailsSection = ({ hideModal, isFullModal, modalData }) => {
  const { entity, plan, handleDetailsSubmit, getInitialValues } = React.useContext(ActionContext)
  const { shouldShowModalActions } = React.useContext(DetailsModalActionsContext)

  const initialValues = useInitialValues(getInitialValues, entity)

  return (
    <Wrapper $isFullModal={isFullModal} $shouldShowModalActions={shouldShowModalActions}>
      <DetailsForm
        entity={entity}
        form={Forms.ACTION_DETAILS_FORM}
        hideModal={hideModal}
        initialValues={initialValues}
        key={entity.id}
        onSubmit={handleDetailsSubmit}
      />
      <PlanLinks
        entity={entity}
        disabled={plan.locked}
        query={PLAN_ACTION_DETAILS_QUERY}
        variables={{
          filter: {
            ids: [entity.id]
          }
        }}
      />
      {shouldShowModalActions && (
        <AdditionalModalActions
          entity={{ ...entity, entityType: ENTITIES.PLAN_ACTION, planId: plan.id }}
          hideModal={hideModal}
          isSubPlan={modalData.isSubPlan}
          plan={modalData.parentPlan}
          sourceItems={modalData.sourceItems}
        />
      )}
    </Wrapper>
  )
}

export default withDropzone(DetailsSection)
